<template>
    <section class="app-wrapper" :class="{shrink:$store.state.collapse}">
        <!-- 左侧导航 -->
        <sidebar class="sidebar-container"></sidebar>
        <!-- 右侧区域 -->
        <el-scrollbar wrapClass="scrollbar-wrapper" style="height:100%;">
            <div class="main-wrapper">
                <!-- 顶部导航 -->
                <navbar></navbar>
                <!-- 主要内容区域 -->
                <transition name="el-fade-in-linear" mode="out-in">

                    <!-- 使用标记缓存方式 -->
                    <!-- <keep-alive :include="$store.state.cachedViews">
                        <router-view :key="$route.fullPath" class="main-box"></router-view>
                    </keep-alive> -->

                    <!-- 使用全缓存，设置最大缓存数 -->
                    <!-- <keep-alive :max="max">
                        <router-view :key="$route.path" class="main-box"></router-view>
                    </keep-alive> -->

                    <!-- 动态组件缓存 -->
                        <keep-alive :include="$store.state.cachedViews">
                            <router-view :key="$route.path" class="main-box"></router-view>
                        </keep-alive>
                </transition>
            </div>
        </el-scrollbar>
    </section>
</template>

<script>
import { CACHE_LIMIT } from '@/constant'
import Sidebar from './components/Sidebar'
import Navbar from './components/Navbar'
export default {
    data() {
        return {
            max: CACHE_LIMIT
        }
    },
    methods: {
        showSideTips() {
            const self = this
            const h = this.$createElement
            const list = [{
                title: '友情提醒',
                message: '您有一条重要消息，请及时查看',
                url: '/component/test'
            }, {
                title: '友情提醒',
                message: '您有一条重要通知，请及时处理',
                url: '/system/permission'
            }]
            list.forEach((item, index) => {
                setTimeout(() => {
                    this.$notify({
                        title: item.title,
                        duration: 3000,
                        type: 'warning',
                        message: h('a', {style: 'color: yellowgreen'}, item.message),
                        onClick() {
                            self.$router.push(item.url)
                            this.close()
                        }
                    })
                }, (index + 1) * 300)
            })
        }
    },
    mounted() {
        // this.showSideTips()
    },
    components: {
        Sidebar,
        Navbar
    }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue